

import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    DailyWageReport,
    Repair,
    User,
} from '@/clients/omb-api';
import ReportCard from '@/components/ReportCard.vue';
import clone from 'clone';
import EditDailyWageReportDialog from '@/components/dialogs/EditDailyWageReportDialog.vue';
import EditWeeklyReportDialog from '@/components/dialogs/EditWeeklyReportDialog.vue';
import Loading from '@/components/Loading.vue';
import { ROLE } from '@/assets/ts/enum/role';
import Service from '@/services/Service';

@Component({
    components: {
        Loading,
        EditWeeklyReportDialog,
        EditDailyWageReportDialog,
        ReportCard,
    },
})
export default class RepairDailyWageReports extends Vue {

    @Prop({ required: true })
    private currentUser!: User;

    @Prop({ required: true })
    private repair!: Repair;

    private loading = true;
    private loadingError = false;
    private dailyWageReports: DailyWageReport[] = [];

    private dailyWageReportDialogVisible = false;
    private dailyWageReportToEdit: DailyWageReport | null = null;

    private get canEdit(): boolean {
        return !!this.currentUser.id && [ROLE.ADMINISTRATOR, ROLE.PLANNING, ROLE.EPLANNING, ROLE.ASSEMBLY, ROLE.EASSEMBLY].includes(this.currentUser.role as ROLE);
    }

    private async created(): Promise<void> {
        await this.fetchReports();
        Service.reports.addDailyWageReportUploadListener(this.onDailyWageReportUpload);
    }

    private destroyed() {
        Service.reports.removeDailyWageReportUploadListener(this.onDailyWageReportUpload);
    }

    private async fetchReports(): Promise<void> {
        try {
            this.loading = true;
            this.dailyWageReports = await Service.reports.getDailyWageReportsByRepair(this.repair.id || 0);
        } catch (e) {
            console.error('failed to load daily wage reports', e);
            this.loadingError = true;
        } finally {
            this.loading = false;
        }
    }

    private showNewDailyWageReportDialog() {
        this.dailyWageReportDialogVisible = true;
    }

    private editDailyWageReport(report: DailyWageReport) {
        this.dailyWageReportToEdit = clone(report);
        this.dailyWageReportDialogVisible = true;
    }

    private hideDailyWageReportDialog() {
        this.dailyWageReportDialogVisible = false;
        this.dailyWageReportToEdit = null;
    }

    private onDailyWageReportUpdate(report: DailyWageReport) {
        if (this.dailyWageReports.find((r) => r.id === report.id)) {
            this.dailyWageReports = this.dailyWageReports.map((r) => (r.id === report.id ? report : r));
        } else {
            this.dailyWageReports.push(report);
        }
        this.$emit('update');
    }

    private onDailyWageReportUpload(): void {
        this.fetchReports();
        this.$emit('update');
    }

    private onDailyWageReportDelete(reportId: number | undefined) {
        this.dailyWageReportDialogVisible = false;
        this.dailyWageReportToEdit = null;
        this.dailyWageReports = this.dailyWageReports.filter((report) => report.id !== reportId);
        this.$emit('update');
    }

}
